export const contact = {
  mail: "help@brocc.se",
  tel: "+46 (0)8 - 50 12 15 80",
}
